<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-list-box" icon-small title="لیست درخواست وام ها" color="secondary">
			<template #topActions>
				<div class="d-flex justify-end">
				</div>
			</template>
			<div class="pa-5 pt-0">
				<v-row>
					<v-col cols="12" class="d-flex justify-center">
						<v-btn-toggle multiple v-model="statusFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
							<v-btn v-for="status in statuses" :key="status.id" :value="status.id" class="rounded-xl mx-1">
								{{ status.title }}
								<v-badge color="blue" :content="items.filter(x => x.userLoanSponsorStatus == status.id).length || '0'" inline>
								</v-badge>
							</v-btn>
						</v-btn-toggle>
					</v-col>
				</v-row>
				<v-row class="justify-center">
					<v-col cols="12" md="6">
						<v-slide-x-transition :hide-on-leave="true">
							<date-navigator v-show="showDateRange" v-model="dateRange" :options="{ rangeMode: true, defaultEmpty: true }">
								<div class="text-center">
									<v-btn color="secondary" dark small class="mx-1" @click="loadData()">
										دریافت اطلاعات
									</v-btn>
								</div>
							</date-navigator>
						</v-slide-x-transition>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" md="6">
						<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
					</v-col>
					<v-col cols="12" md="6" class="d-flex justify-end">
						<v-btn small color="primary" title="دریافت اطلاعات" class="mx-1" fab outlined :loading="loading" @click="loadData()">
							<v-icon>mdi-refresh</v-icon>
						</v-btn>
						<v-btn small color="primary" title="فیلتر تاریخ" class="mx-1" fab outlined @click="showDateRange = !showDateRange">
							<v-icon>mdi-calendar</v-icon>
						</v-btn>
						<export-excel :items="items" :headers="headers" :fileName="excelFileName" :ignoreCheckPermission="true">
						</export-excel>
					</v-col>
					<v-col cols="12">
						<v-data-table :height="dataTableFixedHeight - 100" fixed-header :loading="loading" :headers="headers" :items="filteredItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
							<template v-slot:item.code="{ item }">
								<div class="text-center">
									شماره درخواست: {{ item.code }}
								</div>
								<div class="my-1"><small>{{ item.loanModel.title }}</small></div>
								<div class="text-center">
									<v-btn class="mx-1" x-small color="secondary" @click="edit(item)">
										مشاهده
									</v-btn>
								</div>
							</template>
							<template v-slot:item.memberModel.fullName="{ item }">
								<div>{{ item.memberModel.fullName }}</div>
								<div class="grey--text">{{ item.memberModel.nationalCode }}</div>
							</template>
							<template v-slot:item.amount="{ item }">
								<div class="text-center">
									{{ item.amount.toString().toPriceFormat() }}
								</div>
							</template>
							<template v-slot:item.requestDate_Persian="{ item }">
								<div class="text-center ltr">
									{{ `${item.requestDate_Persian.date} ${item.requestDate_Persian.time}` }}
								</div>
							</template>
							<template v-slot:item.str_UserLoanSponsorStatus="{ item }">
								<div class="text-center">
									{{ item.str_UserLoanSponsorStatus }}
								</div>
							</template>
							<template v-slot:item.lastSponsorComment="{ item }">
								<div>
									{{ (item.lastSponsorComment || "-").length > 100 ? (item.lastSponsorComment || "-").substring(0, 100) + '...' : (item.lastSponsorComment || "-") }}
								</div>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</div>

			<v-dialog v-model="dialog" scrollable persistent max-width="1100px">
				<modify-request ref="modifyRequest" v-if="dialog" :data="selectedRequest" :user="selectedRequest.memberModel" @callbck="callbck" @close="dialog = false" />
			</v-dialog>

		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	// Utilities
	import { get } from 'vuex-pathify'
	import Vue from 'vue'
	import api from '@/util/app-api'
	import router from '@/router'
	import toast from '@/util/toast'
	import { sponsorStatuses } from '@/util/enums'

	const lineSmooth = Vue.chartist.Interpolation.cardinal({
		tension: 0,
	})

	export default {
		name: 'SponsorDashboardView',
		components: {
			'modify-request': () => import('./ModifyLoanRequest.vue'),
		},
		data() {
			return {
				errorMessages: '',
				localData: {},
				selectedRequest: {},
				selectedCustomer: {},
				dialog: false,
				dialogCustomer: false,
				search: '',
				dateRange: { start: '', end: '' },
				headers: [
					{
						text: 'اطلاعات درخواست',
						align: 'start',
						sortable: true,
						value: 'code',
						width: 200
					}, {
						text: 'نام مشتری',
						align: 'start',
						sortable: true,
						value: 'memberModel.fullName',
						width: 150
					}, {
						text: 'کد ملی',
						align: ' d-none',
						sortable: true,
						value: 'memberModel.nationalCode',
					}, {
						text: 'وام درخواستی',
						align: 'start d-none',
						sortable: true,
						value: 'loanModel.title',
					},
					{
						text: 'مبلغ',
						align: 'center',
						sortable: true,
						value: 'amount',
					},
					{
						text: 'تاریخ ثبت درخواست',
						align: 'center',
						sortable: true,
						value: 'requestDate_Persian',
					},
					{
						text: 'وضعیت درخواست',
						align: 'center',
						sortable: true,
						value: 'str_UserLoanSponsorStatus',
					},
					{
						text: 'آخرین توضیحات اسپانسر',
						align: 'start',
						sortable: true,
						value: 'lastSponsorComment',
						width: 200
					}
				],
				items: [],
				statuses: sponsorStatuses,
				statusFilter: [],
				loading: false,
				showDateRange: false
			}
		},
		mounted() {
			this.loadData()
		},
		computed: {
			...get('auth', [
				'getCurrentUser',
			]),
			...get('siteConfig', [
				'isCloud', 'baseUrl'
			]),
			customerCode() {
				var user = this.getCurrentUser
				if (user && user.userData && user.userData.customer)
					return `${user.userData.customer.code}`
				return ''
			},
			excelFileName() {
				let name = 'گزارش درخواست وام ها'
				if (this.dateRange.start)
					name += ' از ' + this.dateRange.start.toString().split('T')[0]
				if (this.dateRange.end)
					name += ' تا ' + this.dateRange.end.toString().split('T')[0]
				name += '.xls'
				return name
			},
			filteredItems() {
				if (!(this.statusFilter || []).length)
					return this.items
				let clonedItems = []
				clonedItems.push(...this.items)
				clonedItems = clonedItems.filter(x => this.statusFilter.indexOf(x.userLoanSponsorStatus) > -1)
				return clonedItems
			}
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('sponsor/userLoanRequest/list?start=' + this.dateRange.start + '&end=' + this.dateRange.end, null)
					.then(response => {
						this.items = response
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			edit(item) {
				this.dialog = true
				this.selectedRequest = item
			},
			callbck(result) {
				if (result === 'close') {
					this.dialog = false
					return
				}
				if (result) {
					this.loadData()
				}
			}
		}
	}
</script>
<style></style>
